<mat-toolbar color="primary" class="example-toolbar">
  <div class="top-nav-start">
    <button mat-icon-button (click)="isExpanded = !isExpanded"><mat-icon>menu</mat-icon></button>
    <div class="LogoContainer">
      <img src="assets/images/AICTELogo.png" alt="Logo" class="logoImg" />
      <img src="assets/images/SLALogo.png" alt="Logo" class="logoImg" />
    </div>
  </div>
  <div class="rad-top-nav-container">
    <ul class="pull-right links">
      <li class="rad-dropdown no-color">
        <button mat-icon-button [matMenuTriggerFor]="menu">
          <img
            class="rad-list-img sm-img"
            src="https://lh4.googleusercontent.com/-GXmmnYTuWkg/AAAAAAAAAAI/AAAAAAAAAAA/oK6DEDS7grM/w56-h56/photo.jpg"
            alt="me"
          />
        </button>
        <mat-menu #menu="matMenu" class="profileMainDD">
          <div class="profileDropdown">
            <img
              class="profileImageDD"
              src="https://lh4.googleusercontent.com/-GXmmnYTuWkg/AAAAAAAAAAI/AAAAAAAAAAA/oK6DEDS7grM/w56-h56/photo.jpg"
              alt="me"
            />
            <p class="profileNameDD">Vikas Puri <span>(Admin)</span></p>
            <p class="profileMailDD">admin@example.com</p>
          </div>
          <div class="profileOptionDD">
            <ul class="DDOptions">
              <li class="DDListItem">View Profile</li>
              <li class="DDListItem">Log Out</li>
            </ul>
          </div>
        </mat-menu>
      </li>
      <li class="rad-dropdown">
        <button
          mat-icon-button
          [matMenuTriggerFor]="settingMenu"
          aria-label="Example icon-button with a menu"
        >
          <i class="fa fa-cog"></i>
        </button>
        <mat-menu #settingMenu="matMenu">
          <button mat-menu-item>
            <mat-icon>dialpad</mat-icon>
            <span>Redial 1</span>
          </button>
          <button mat-menu-item disabled>
            <mat-icon>voicemail</mat-icon>
            <span>Check voice mail 1</span>
          </button>
          <button mat-menu-item>
            <mat-icon>notifications_off</mat-icon>
            <span>Disable alerts 1</span>
          </button>
        </mat-menu>
      </li>
    </ul>
    <ul class="pull-right links">
      <li class="rad-dropdown">
        <button
          mat-icon-button
          [matMenuTriggerFor]="CommentMenu"
          class="rad-menu-item"
        >
          <i class="fa fa-comment-o"
            ><span class="rad-menu-badge rad-bg-success">0</span></i
          >
        </button>
        <mat-menu #CommentMenu="matMenu">
          <button mat-menu-item>
            <mat-icon>dialpad</mat-icon>
            <span>Comment</span>
          </button>
          <button mat-menu-item disabled>
            <mat-icon>voicemail</mat-icon>
            <span>Check voice mail</span>
          </button>
          <button mat-menu-item>
            <mat-icon>notifications_off</mat-icon>
            <span>Disable alerts</span>
          </button>
        </mat-menu>
      </li>
      <li class="rad-dropdown">
        <button
          mat-icon-button
          [matMenuTriggerFor]="NotificationMenu"
          class="rad-menu-item"
        >
          <i class="fa fa-envelope-o"
            ><span class="rad-menu-badge rad-bg-primary">23</span></i
          >
        </button>
        <mat-menu #NotificationMenu="matMenu">
          <button mat-menu-item>
            <mat-icon>dialpad</mat-icon>
            <span>Notification</span>
          </button>
        </mat-menu>
      </li>
      <li class="rad-dropdown">
        <button
          mat-icon-button
          [matMenuTriggerFor]="AlertsMenu"
          class="rad-menu-item"
        >
          <i class="fa fa-bell-o"><span class="rad-menu-badge">49</span></i>
        </button>
        <mat-menu #AlertsMenu="matMenu">
          <button mat-menu-item>
            <mat-icon>dialpad</mat-icon>
            <span>Alerts</span>
          </button>
        </mat-menu>
      </li>
    </ul>
  </div>
</mat-toolbar>
<mat-sidenav-container class="example-container" autosize>
    <mat-sidenav class="example-sidenav" mode="side" opened="true" *ngIf="isExpanded && isShowing">
      <!-- <div class="sideMenuUserProfile">
              <img class="sideMenuUserImage" src="https://lh4.googleusercontent.com/-GXmmnYTuWkg/AAAAAAAAAAI/AAAAAAAAAAA/oK6DEDS7grM/w56-h56/photo.jpg" alt="me" />
              <p class="sideMenuUserName">Vikas Puri <span>( Admin )</span>
              <button mat-icon-button [matMenuTriggerFor]="sideprofilemenu" class="profileDropbtn">
                  <mat-icon>arrow_drop_down</mat-icon>
                </button>
              </p>
                <mat-menu #sideprofilemenu="matMenu" xPosition="before">
                  <button mat-menu-item>
                    <mat-icon>dialpad</mat-icon>
                    <span>Redial</span>
                  </button>
                  <button mat-menu-item disabled>
                    <mat-icon>voicemail</mat-icon>
                    <span>Check voice mail</span>
                  </button>
                  <button mat-menu-item>
                    <mat-icon>notifications_off</mat-icon>
                    <span>Disable alerts</span>
                  </button>
                </mat-menu>
              <p class="sideMenuUserEmail">admin@example.com</p>
          
          </div> -->
      <mat-nav-list>
          <mat-list-item>
              <span class="full-width" *ngIf="isExpanded">Student Dashboard</span>
              <mat-icon mat-list-icon>dashboard</mat-icon>
          </mat-list-item>
          <mat-accordion multi="true" class="sidenav_Menu">
              <mat-expansion-panel class="no-shadow">
                <mat-expansion-panel-header fxLayout="row" [expandedHeight]="expandHeight" [collapsedHeight]="collapseHeight">
                  <mat-panel-title><mat-icon mat-list-icon>apps</mat-icon> Application Details </mat-panel-title>
                </mat-expansion-panel-header>
                <mat-nav-list class="ml-0" dense>
                  <mat-list-item>
                      <a mat-list-item href="..." ><mat-icon mat-list-icon>description</mat-icon> Basic Details</a>
                  </mat-list-item>
                  <mat-list-item>
                      <a mat-list-item href="..."><mat-icon mat-list-icon>business</mat-icon> Institute Details</a>
                  </mat-list-item>
                  <mat-list-item>
                      <a mat-list-item href="..."><mat-icon mat-list-icon>import_contacts</mat-icon> Educational Qualifications</a>
                  </mat-list-item>
                  <mat-list-item>
                      <a mat-list-item href="..."><mat-icon mat-list-icon>school</mat-icon> Graduation Details</a>
                  </mat-list-item>
                  <mat-list-item>
                      <a mat-list-item href="..."><mat-icon mat-list-icon>attach_file</mat-icon> Attachments</a>
                  </mat-list-item>
                </mat-nav-list>
              </mat-expansion-panel>
              <mat-expansion-panel class="no-shadow my-0">
                <mat-expansion-panel-header fxLayout="row" [expandedHeight]="expandHeight" [collapsedHeight]="collapseHeight">
                  <mat-panel-title>
                    Buy Airtime
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <mat-nav-list class="ml-0" dense>
                  <mat-list-item>
                    <a href="#">AirtelTigo Airtime</a>
                  </mat-list-item>
                  <mat-list-item>
                    <a href="#">Vodafone Airtime</a>
                  </mat-list-item>
                  <mat-list-item>
                    <a href="#">MTN Airtime</a>
                  </mat-list-item>
                  <mat-list-item>
                    <a href="#">GLO Airtime</a>
                  </mat-list-item>
                </mat-nav-list>
              </mat-expansion-panel>
          </mat-accordion>
      </mat-nav-list>
    </mat-sidenav>

    <div class="example-sidenav-content">
      <div class="dashboardHeader">
        <h4 class="dashboardHeading text-shadow">Dashboard</h4>
        <p class="m-0 text-shadow">Breadcrumb</p>
      </div>
      <div class="col-12 cardContainer">
          <div class="card CardItem topcardContainer">
            <img
              src="assets/images/badge.svg"
              alt="Medal Pic"
              class="congratulation-medal"
            />
            <div class="detailContainer">
              <h5 class="greetingText">Congratulations 🎉 Vikas Puri!</h5>
              <p class="greetingDetailText">
                You have completed <strong>20</strong> Assessments Successfully
              </p>
            </div>
            <div class="assessmentDetailContatiner">
              <div class="assessmentCountContainer border-right-1">
                <h5 class="AssessmentHeading">Mock Assessment</h5>
                <p class="AssessmentCount">15</p>
              </div>
              <div class="assessmentCountContainer">
                <h5 class="AssessmentHeading">Real Assessment</h5>
                <p class="AssessmentCount">5</p>
              </div>
            </div>
            <div class="buttonContainer">
              <button
                type="button"
                rippleeffect=""
                class="btn btn-primary waves-effect waves-float waves-light"
              >
                View Reports
              </button>
            </div>
          </div>
          <div class="card CardItem topcardContainer">
            <div>
              <h5 class="topScrorerHeading">Top Scorer</h5>
            </div>
            <div class="topScrorerCardContainer">
              <div class="card topScrorerCard box1">
                <img src="assets/images/celebration.png" class="backgroundImg" />
                <img
                  src="https://lh4.googleusercontent.com/-GXmmnYTuWkg/AAAAAAAAAAI/AAAAAAAAAAA/oK6DEDS7grM/w56-h56/photo.jpg"
                  class="topStudentImg"
                />
                <p class="studentName">Student Name</p>
                <p class="schoolName">School Name</p>
                <p class="percentage">98.99 %</p>
                <p class="resultPosition">1st</p>
              </div>
              <div class="card topScrorerCard box3">
                <img src="assets/images/celebration.png" class="backgroundImg" />
                <img
                  src="https://lh4.googleusercontent.com/-GXmmnYTuWkg/AAAAAAAAAAI/AAAAAAAAAAA/oK6DEDS7grM/w56-h56/photo.jpg"
                  class="topStudentImg"
                />
                <p class="studentName">Student Name</p>
                <p class="schoolName">School Name</p>
                <p class="percentage">98.99 %</p>
                <p class="resultPosition">2nd</p>
              </div>
              <div class="card topScrorerCard box4">
                <img src="assets/images/celebration.png" class="backgroundImg" />
                <img
                  src="https://lh4.googleusercontent.com/-GXmmnYTuWkg/AAAAAAAAAAI/AAAAAAAAAAA/oK6DEDS7grM/w56-h56/photo.jpg"
                  class="topStudentImg"
                />
                <p class="studentName">Student Name</p>
                <p class="schoolName">School Name</p>
                <p class="percentage">98.99 %</p>
                <p class="resultPosition">3rd</p>
              </div>
            </div>
          </div>
          <div #containerRef class="card CardItem">
            <h5 class="chartHeading">Student Record 1</h5>
            <div style="padding: 0 15px;position: relative;">
                <p style="font-size: 14px;font-weight: 600;margin-bottom: 5px;">Aptitude</p>
                <mat-progress-bar
                    class="example-margin"
                    [color]="color"
                    [value]= 70
                    [bufferValue]=75>
                </mat-progress-bar>
                <div style="position: absolute;padding: 10px;color: white;font-size: 10px;bottom: -5px;font-weight: 600;"> 70% </div>
            </div>
            <div style="padding: 0 15px;position: relative;">
                <p style="font-size: 14px;font-weight: 600;margin-bottom: 5px;">Engineering</p>
                <mat-progress-bar
                    class="example-margin"
                    [color]="color"
                    [value]= 47
                    [bufferValue]=75>
                </mat-progress-bar>
                <div style="position: absolute;padding: 10px;color: white;font-size: 10px;bottom: -5px;font-weight: 600;"> 47% </div>
            </div>
            <div style="padding: 0 15px;position: relative;">
                <p style="font-size: 14px;font-weight: 600;margin-bottom: 5px;">Emerging Area</p>
                <mat-progress-bar
                    class="example-margin"
                    [color]="color"
                    [value]= 89
                    [bufferValue]=75>
                </mat-progress-bar>
                <div style="position: absolute;padding: 10px;color: white;font-size: 10px;bottom: -5px;font-weight: 600;"> 89% </div>
            </div>
          </div>
          <div #containerRef1 class="card CardItem">
            <h5 class="chartHeading">Student Record 2</h5>
            <ngx-charts-line-chart
              [view]="[containerRef1.offsetWidth + 40, 200]"
              [scheme]="{ domain: ['#ff9f43', '#7367f0', '#C7B42C', '#AAAAAA'] }"
              [results]="multi"
              [gradient]="true"
              [xAxis]="false"
              [yAxis]="false"
              [legend]="false"
              [legendTitle]="'Legenda'"
              [xAxisLabel]="'Jaar'"
              [yAxisLabel]="'Aantal Leden'"
              [showXAxisLabel]="true"
              [showYAxisLabel]="true"
              [animations]="true"
              style="
                top: 70px;
                position: absolute;
                z-index: 9999999;
                left: -20px;
                overflow: hidden;
                height: 150px;
              "
            >
            </ngx-charts-line-chart>
          </div>
          <div #containerRef2 class="card CardItem">
            <h5 class="chartHeading">Student Record 3</h5>
            <ngx-charts-line-chart
              [view]="[containerRef2.offsetWidth + 40, 200]"
              [scheme]="{ domain: ['#ff9f43', '#7367f0', '#C7B42C', '#AAAAAA'] }"
              [results]="student1"
              [gradient]="true"
              [xAxis]="false"
              [yAxis]="false"
              [legend]="false"
              [legendTitle]="'Legenda'"
              [xAxisLabel]="'Jaar'"
              [yAxisLabel]="'Aantal Leden'"
              [showXAxisLabel]="true"
              [showYAxisLabel]="true"
              [animations]="true"
              style="
                bottom: 5px;
                position: absolute;
                z-index: 9999999;
                left: -20px;
                overflow: hidden;
                height: 150px;
              "
            >
            </ngx-charts-line-chart>
          </div>
          <div #containerRef3 class="card CardItem">
            <h5 class="chartHeading">Student Record 4</h5>
            <ngx-charts-pie-grid
              [view]="[containerRef3.offsetWidth + 40, 180]"
              [scheme]="{ domain: ['#ff9f43', '#7367f0', '#C7B42C', '#AAAAAA'] }"
              [results]="student2"
              [animations]="true"
              style="
                bottom: -10px;
                position: absolute;
                z-index: 9999999;
                left: -20px;
                overflow: hidden;
              "
            >
            </ngx-charts-pie-grid>
          </div>
          <div class="card CardItem">
            <h5 class="chartHeading">Student Record 5</h5>
            <apx-chart
              [series]="chartOptions.series"
              [chart]="chartOptions.chart"
              [stroke]="chartOptions.stroke"
              [fill]="chartOptions.fill"
            ></apx-chart>
          </div>
          <div class="card CardItem">
            <h5 class="chartHeading">Student Record 6</h5>
            <apx-chart
              [series]="chartOptions2.series"
              [chart]="chartOptions2.chart"
              [plotOptions]="chartOptions2.plotOptions"
              [labels]="chartOptions2.labels"
            ></apx-chart>
          </div>
          <div class="card CardItem">
            <h5 class="chartHeading">Student Record 7</h5>
            <apx-chart
              #supportChartRef
              [series]="supportChartoptions.series"
              [chart]="supportChartoptions.chart"
              [plotOptions]="supportChartoptions.plotOptions"
              [colors]="supportChartoptions.colors"
              [fill]="supportChartoptions.fill"
              [stroke]="supportChartoptions.stroke"
              style="
                bottom: -10px;
                width: 100%;
                position: absolute;
                z-index: 9999999;
                left: -10px;
                overflow: hidden;
              "
            >
            </apx-chart>
          </div>
          <div class="card CardItem">
            <h5 class="chartHeading">Student Record 8</h5>
            <apx-chart
              [series]="RadialBar.series"
              [chart]="RadialBar.chart"
              [plotOptions]="RadialBar.plotOptions"
              [labels]="RadialBar.labels"
              [legend]="RadialBar.legend"
              [colors]="RadialBar.colors"
              [responsive]="RadialBar.responsive"
            >
            </apx-chart>
          </div>
          <div class="card CardItem">
            <h5 class="chartHeading">Student Record 9</h5>
            <mat-calendar
              [selected]="selectedDate"
              [startAt]="startAt"
              [minDate]="minDate"
              [maxDate]="maxDate"
              [dateFilter]="myDateFilter"
              (selectedChange)="onSelect($event)"
            >
            </mat-calendar>
          </div>
          <div class="card CardItem" style="flex: 0 0 73%">
            <h5 class="chartHeading">Student Record 10</h5>
            <apx-chart
              [series]="student10.series"
              [chart]="student10.chart"
              [dataLabels]="student10.dataLabels"
              [plotOptions]="student10.plotOptions"
              [yaxis]="student10.yaxis"
              [xaxis]="student10.xaxis"
              [stroke]="student10.stroke"
              [grid]="student10.grid"
              [fill]="student10.fill"
              [annotations]="student10.annotations"
            >
            </apx-chart>
          </div>
          <div class="card CardItem" style="flex: 0 0 48%">
            <h5 class="chartHeading">Student Record 11</h5>
            <table mat-table [dataSource]="dataSource">
              <!-- Position Column -->
              <ng-container matColumnDef="position">
                <th mat-header-cell *matHeaderCellDef>No.</th>
                <td mat-cell *matCellDef="let element">{{ element.position }}</td>
              </ng-container>
    
              <!-- Name Column -->
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>Name</th>
                <td mat-cell *matCellDef="let element">{{ element.name }}</td>
              </ng-container>
    
              <!-- Weight Column -->
              <ng-container matColumnDef="weight">
                <th mat-header-cell *matHeaderCellDef>Weight</th>
                <td mat-cell *matCellDef="let element">{{ element.weight }}</td>
              </ng-container>
    
              <!-- Symbol Column -->
              <ng-container matColumnDef="symbol">
                <th mat-header-cell *matHeaderCellDef>Symbol</th>
                <td mat-cell *matCellDef="let element">{{ element.symbol }}</td>
              </ng-container>
    
              <tr
                mat-header-row
                *matHeaderRowDef="columnsToDisplay; sticky: true"
              ></tr>
              <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
            </table>
            <mat-paginator
              #paginator="matPaginator"
              [pageSize]="5"
              showFirstLastButtons
            >
            </mat-paginator>
          </div>
          <div class="card CardItem" style="flex: 0 0 48%">
            <h5 class="chartHeading">Student Record 12</h5>
            <table mat-table [dataSource]="dataSource1">
              <!-- Position Column -->
              <ng-container matColumnDef="position">
                <th mat-header-cell *matHeaderCellDef>No.</th>
                <td mat-cell *matCellDef="let element">{{ element.position }}</td>
              </ng-container>
    
              <!-- Name Column -->
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>Name</th>
                <td mat-cell *matCellDef="let element">{{ element.name }}</td>
              </ng-container>
    
              <!-- Weight Column -->
              <ng-container matColumnDef="weight">
                <th mat-header-cell *matHeaderCellDef>Weight</th>
                <td mat-cell *matCellDef="let element">{{ element.weight }}</td>
              </ng-container>
    
              <!-- Symbol Column -->
              <ng-container matColumnDef="symbol">
                <th mat-header-cell *matHeaderCellDef>Symbol</th>
                <td mat-cell *matCellDef="let element">{{ element.symbol }}</td>
              </ng-container>
    
              <tr
                mat-header-row
                *matHeaderRowDef="columnsToDisplay1; sticky: true"
              ></tr>
              <tr mat-row *matRowDef="let row; columns: columnsToDisplay1"></tr>
            </table>
    
            <mat-paginator
              #paginator1="matPaginator"
              [pageSize]="5"
              showFirstLastButtons
            >
            </mat-paginator>
          </div>
          <div class="card CardItem">
            <h5 class="chartHeading">Student Record 13</h5>
            <apx-chart
              [series]="student13.series"
              [chart]="student13.chart"
              [xaxis]="student13.xaxis"
            ></apx-chart>
          </div>
          <div class="card CardItem" style="flex: 0 0 48%">
            <h5 class="chartHeading">Student Record 14</h5>
            <apx-chart
              [series]="student14.series"
              [chart]="student14.chart"
              [dataLabels]="student14.dataLabels"
              [plotOptions]="student14.plotOptions"
              [yaxis]="student14.yaxis"
              [legend]="student14.legend"
              [fill]="student14.fill"
              [stroke]="student14.stroke"
              [tooltip]="student14.tooltip"
              [xaxis]="student14.xaxis"
            ></apx-chart>
          </div>
          <div class="card CardItem">
            <h5 class="chartHeading">Student Record 15</h5>
            <apx-chart
              [series]="student15.series"
              [chart]="student15.chart"
              [dataLabels]="student15.dataLabels"
              [plotOptions]="student15.plotOptions"
            ></apx-chart>
          </div>
          <div class="card CardItem" style="flex: 0 0 100%">
            <h5 class="chartHeading">Student Record 16</h5>
            <table
              id="table1"
              mat-table
              [dataSource]="dataSource2"
              multiTemplateDataRows
              class="mat-elevation-z8"
            >
              <ng-container
                matColumnDef="{{ column }}"
                *ngFor="let column of columnsToDisplay2"
              >
                <th mat-header-cell *matHeaderCellDef>{{ column }}</th>
                <td mat-cell *matCellDef="let element">{{ element[column] }}</td>
              </ng-container>
    
              <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
              <ng-container matColumnDef="expandedDetail">
                <td
                  mat-cell
                  *matCellDef="let element"
                  [attr.colspan]="columnsToDisplay2.length"
                >
                  <div
                    class="example-element-detail"
                    [@detailExpand]="
                      element == expandedElement ? 'expanded' : 'collapsed'
                    "
                  >
                    <div class="example-element-diagram">
                      <div class="example-element-position">
                        {{ element.position }}
                      </div>
                      <div class="example-element-symbol">{{ element.symbol }}</div>
                      <div class="example-element-name">{{ element.name }}</div>
                      <div class="example-element-weight">{{ element.weight }}</div>
                    </div>
                    <div class="example-element-description">
                      {{ element.description }}
                      <span class="example-element-description-attribution">
                        -- Wikipedia
                      </span>
                    </div>
                  </div>
                </td>
              </ng-container>
    
              <tr mat-header-row *matHeaderRowDef="columnsToDisplay2"></tr>
              <tr
                mat-row
                *matRowDef="let element; columns: columnsToDisplay2"
                class="example-element-row"
                [class.example-expanded-row]="expandedElement === element"
                (click)="
                  expandedElement = expandedElement === element ? null : element
                "
              ></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: ['expandedDetail']"
                class="example-detail-row"
              ></tr>
            </table>
            <mat-paginator
              #paginator2="matPaginator"
              [pageSize]="5"
              [pageSizeOptions]="[5, 10, 25, 100]"
              showFirstLastButtons
            >
            </mat-paginator>
          </div>
        </div>
        <div class="col-12 cardContainer studentDashboard">
          <div class="card CardItem topcardContainer">
            <img
              src="assets/images/badge.svg"
              alt="Medal Pic"
              class="congratulation-medal"
            />
            <div class="detailContainer">
              <h5 class="greetingText">Congratulations 🎉 Vikas Puri!</h5>
              <p class="greetingDetailText">
                You have completed <strong>20</strong> Assessments Successfully
              </p>
            </div>
            <div class="assessmentDetailContatiner">
              <div class="assessmentCountContainer border-right-1">
                <h5 class="AssessmentHeading">Mock Assessment</h5>
                <p class="AssessmentCount">15</p>
              </div>
              <div class="assessmentCountContainer">
                <h5 class="AssessmentHeading">Real Assessment</h5>
                <p class="AssessmentCount">5</p>
              </div>
            </div>
            <div class="buttonContainer">
              <button
                type="button"
                rippleeffect=""
                class="btn btn-primary waves-effect waves-float waves-light"
              >
                View Reports
              </button>
            </div>
          </div>
          <div class="card CardItem topcardContainer">
            <div>
              <h5 class="topScrorerHeading">Top Scorer</h5>
            </div>
            <div class="topScrorerCardContainer">
              <div class="card topScrorerCard box1">
                <img src="assets/images/celebration.png" class="backgroundImg" />
                <img
                  src="https://lh4.googleusercontent.com/-GXmmnYTuWkg/AAAAAAAAAAI/AAAAAAAAAAA/oK6DEDS7grM/w56-h56/photo.jpg"
                  class="topStudentImg"
                />
                <p class="studentName">Student Name</p>
                <p class="schoolName">School Name</p>
                <p class="percentage">98.99 %</p>
                <p class="resultPosition">1st</p>
              </div>
              <div class="card topScrorerCard box3">
                <img src="assets/images/celebration.png" class="backgroundImg" />
                <img
                  src="https://lh4.googleusercontent.com/-GXmmnYTuWkg/AAAAAAAAAAI/AAAAAAAAAAA/oK6DEDS7grM/w56-h56/photo.jpg"
                  class="topStudentImg"
                />
                <p class="studentName">Student Name</p>
                <p class="schoolName">School Name</p>
                <p class="percentage">98.99 %</p>
                <p class="resultPosition">2nd</p>
              </div>
              <div class="card topScrorerCard box4">
                <img src="assets/images/celebration.png" class="backgroundImg" />
                <img
                  src="https://lh4.googleusercontent.com/-GXmmnYTuWkg/AAAAAAAAAAI/AAAAAAAAAAA/oK6DEDS7grM/w56-h56/photo.jpg"
                  class="topStudentImg"
                />
                <p class="studentName">Student Name</p>
                <p class="schoolName">School Name</p>
                <p class="percentage">98.99 %</p>
                <p class="resultPosition">3rd</p>
              </div>
            </div>
          </div>
          <div #containerRef class="card CardItem">
            <h5 class="chartHeading">Student Record 1</h5>
            <div style="padding: 0 15px;position: relative;">
                <p style="font-size: 14px;font-weight: 600;margin-bottom: 5px;">Aptitude</p>
                <mat-progress-bar
                    class="example-margin"
                    [color]="color"
                    [value]= 70
                    [bufferValue]=75>
                </mat-progress-bar>
                <div style="position: absolute;padding: 10px;color: white;font-size: 10px;bottom: -5px;font-weight: 600;"> 70% </div>
            </div>
            <div style="padding: 0 15px;position: relative;">
                <p style="font-size: 14px;font-weight: 600;margin-bottom: 5px;">Engineering</p>
                <mat-progress-bar
                    class="example-margin"
                    [color]="color"
                    [value]= 47
                    [bufferValue]=75>
                </mat-progress-bar>
                <div style="position: absolute;padding: 10px;color: white;font-size: 10px;bottom: -5px;font-weight: 600;"> 47% </div>
            </div>
            <div style="padding: 0 15px;position: relative;">
                <p style="font-size: 14px;font-weight: 600;margin-bottom: 5px;">Emerging Area</p>
                <mat-progress-bar
                    class="example-margin"
                    [color]="color"
                    [value]= 89
                    [bufferValue]=75>
                </mat-progress-bar>
                <div style="position: absolute;padding: 10px;color: white;font-size: 10px;bottom: -5px;font-weight: 600;"> 89% </div>
            </div>
          </div>
          <div #containerRef1 class="card CardItem">
            <h5 class="chartHeading">Student Record 2</h5>
            <ngx-charts-line-chart
              [view]="[containerRef1.offsetWidth + 40, 200]"
              [scheme]="{ domain: ['#ff9f43', '#7367f0', '#C7B42C', '#AAAAAA'] }"
              [results]="multi"
              [gradient]="true"
              [xAxis]="false"
              [yAxis]="false"
              [legend]="false"
              [legendTitle]="'Legenda'"
              [xAxisLabel]="'Jaar'"
              [yAxisLabel]="'Aantal Leden'"
              [showXAxisLabel]="true"
              [showYAxisLabel]="true"
              [animations]="true"
              style="
                top: 70px;
                position: absolute;
                z-index: 9999999;
                left: -20px;
                overflow: hidden;
                height: 150px;
              "
            >
            </ngx-charts-line-chart>
          </div>
          <div #containerRef2 class="card CardItem">
            <h5 class="chartHeading">Student Record 3</h5>
            <ngx-charts-line-chart
              [view]="[containerRef2.offsetWidth + 40, 200]"
              [scheme]="{ domain: ['#ff9f43', '#7367f0', '#C7B42C', '#AAAAAA'] }"
              [results]="student1"
              [gradient]="true"
              [xAxis]="false"
              [yAxis]="false"
              [legend]="false"
              [legendTitle]="'Legenda'"
              [xAxisLabel]="'Jaar'"
              [yAxisLabel]="'Aantal Leden'"
              [showXAxisLabel]="true"
              [showYAxisLabel]="true"
              [animations]="true"
              style="
                bottom: 5px;
                position: absolute;
                z-index: 9999999;
                left: -20px;
                overflow: hidden;
                height: 150px;
              "
            >
            </ngx-charts-line-chart>
          </div>
          <div #containerRef3 class="card CardItem">
            <h5 class="chartHeading">Student Record 4</h5>
            <ngx-charts-pie-grid
              [view]="[containerRef3.offsetWidth + 40, 180]"
              [scheme]="{ domain: ['#ff9f43', '#7367f0', '#C7B42C', '#AAAAAA'] }"
              [results]="student2"
              [animations]="true"
              style="
                bottom: -10px;
                position: absolute;
                z-index: 9999999;
                left: -20px;
                overflow: hidden;
              "
            >
            </ngx-charts-pie-grid>
          </div>
          <div class="card CardItem">
            <h5 class="chartHeading">Student Record 5</h5>
            <apx-chart
              [series]="chartOptions.series"
              [chart]="chartOptions.chart"
              [stroke]="chartOptions.stroke"
              [fill]="chartOptions.fill"
            ></apx-chart>
          </div>
          <div class="card CardItem">
            <h5 class="chartHeading">Student Record 6</h5>
            <apx-chart
              [series]="chartOptions2.series"
              [chart]="chartOptions2.chart"
              [plotOptions]="chartOptions2.plotOptions"
              [labels]="chartOptions2.labels"
            ></apx-chart>
          </div>
          <div class="card CardItem">
            <h5 class="chartHeading">Student Record 7</h5>
            <apx-chart
              #supportChartRef
              [series]="supportChartoptions.series"
              [chart]="supportChartoptions.chart"
              [plotOptions]="supportChartoptions.plotOptions"
              [colors]="supportChartoptions.colors"
              [fill]="supportChartoptions.fill"
              [stroke]="supportChartoptions.stroke"
              style="
                bottom: -10px;
                width: 100%;
                position: absolute;
                z-index: 9999999;
                left: -10px;
                overflow: hidden;
              "
            >
            </apx-chart>
          </div>
          <div class="card CardItem">
            <h5 class="chartHeading">Student Record 8</h5>
            <apx-chart
              [series]="RadialBar.series"
              [chart]="RadialBar.chart"
              [plotOptions]="RadialBar.plotOptions"
              [labels]="RadialBar.labels"
              [legend]="RadialBar.legend"
              [colors]="RadialBar.colors"
              [responsive]="RadialBar.responsive"
            >
            </apx-chart>
          </div>
          <div class="card CardItem">
            <h5 class="chartHeading">Student Record 9</h5>
            <mat-calendar
              [selected]="selectedDate"
              [startAt]="startAt"
              [minDate]="minDate"
              [maxDate]="maxDate"
              [dateFilter]="myDateFilter"
              (selectedChange)="onSelect($event)"
            >
            </mat-calendar>
          </div>
          <div class="card CardItem" style="flex: 0 0 73%">
            <h5 class="chartHeading">Student Record 10</h5>
            <apx-chart
              [series]="student10.series"
              [chart]="student10.chart"
              [dataLabels]="student10.dataLabels"
              [plotOptions]="student10.plotOptions"
              [yaxis]="student10.yaxis"
              [xaxis]="student10.xaxis"
              [stroke]="student10.stroke"
              [grid]="student10.grid"
              [fill]="student10.fill"
              [annotations]="student10.annotations"
            >
            </apx-chart>
          </div>
          <div class="card CardItem" style="flex: 0 0 48%">
            <h5 class="chartHeading">Student Record 11</h5>
            <table mat-table [dataSource]="dataSource">
              <!-- Position Column -->
              <ng-container matColumnDef="position">
                <th mat-header-cell *matHeaderCellDef>No.</th>
                <td mat-cell *matCellDef="let element">{{ element.position }}</td>
              </ng-container>
    
              <!-- Name Column -->
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>Name</th>
                <td mat-cell *matCellDef="let element">{{ element.name }}</td>
              </ng-container>
    
              <!-- Weight Column -->
              <ng-container matColumnDef="weight">
                <th mat-header-cell *matHeaderCellDef>Weight</th>
                <td mat-cell *matCellDef="let element">{{ element.weight }}</td>
              </ng-container>
    
              <!-- Symbol Column -->
              <ng-container matColumnDef="symbol">
                <th mat-header-cell *matHeaderCellDef>Symbol</th>
                <td mat-cell *matCellDef="let element">{{ element.symbol }}</td>
              </ng-container>
    
              <tr
                mat-header-row
                *matHeaderRowDef="columnsToDisplay; sticky: true"
              ></tr>
              <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
            </table>
            <mat-paginator
              #paginator="matPaginator"
              [pageSize]="5"
              showFirstLastButtons
            >
            </mat-paginator>
          </div>
          <div class="card CardItem" style="flex: 0 0 48%">
            <h5 class="chartHeading">Student Record 12</h5>
            <table mat-table [dataSource]="dataSource1">
              <!-- Position Column -->
              <ng-container matColumnDef="position">
                <th mat-header-cell *matHeaderCellDef>No.</th>
                <td mat-cell *matCellDef="let element">{{ element.position }}</td>
              </ng-container>
    
              <!-- Name Column -->
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>Name</th>
                <td mat-cell *matCellDef="let element">{{ element.name }}</td>
              </ng-container>
    
              <!-- Weight Column -->
              <ng-container matColumnDef="weight">
                <th mat-header-cell *matHeaderCellDef>Weight</th>
                <td mat-cell *matCellDef="let element">{{ element.weight }}</td>
              </ng-container>
    
              <!-- Symbol Column -->
              <ng-container matColumnDef="symbol">
                <th mat-header-cell *matHeaderCellDef>Symbol</th>
                <td mat-cell *matCellDef="let element">{{ element.symbol }}</td>
              </ng-container>
    
              <tr
                mat-header-row
                *matHeaderRowDef="columnsToDisplay1; sticky: true"
              ></tr>
              <tr mat-row *matRowDef="let row; columns: columnsToDisplay1"></tr>
            </table>
    
            <mat-paginator
              #paginator1="matPaginator"
              [pageSize]="5"
              showFirstLastButtons
            >
            </mat-paginator>
          </div>
          <div class="card CardItem">
            <h5 class="chartHeading">Student Record 13</h5>
            <apx-chart
              [series]="student13.series"
              [chart]="student13.chart"
              [xaxis]="student13.xaxis"
            ></apx-chart>
          </div>
          <div class="card CardItem" style="flex: 0 0 48%">
            <h5 class="chartHeading">Student Record 14</h5>
            <apx-chart
              [series]="student14.series"
              [chart]="student14.chart"
              [dataLabels]="student14.dataLabels"
              [plotOptions]="student14.plotOptions"
              [yaxis]="student14.yaxis"
              [legend]="student14.legend"
              [fill]="student14.fill"
              [stroke]="student14.stroke"
              [tooltip]="student14.tooltip"
              [xaxis]="student14.xaxis"
            ></apx-chart>
          </div>
          <div class="card CardItem">
            <h5 class="chartHeading">Student Record 15</h5>
            <apx-chart
              [series]="student15.series"
              [chart]="student15.chart"
              [dataLabels]="student15.dataLabels"
              [plotOptions]="student15.plotOptions"
            ></apx-chart>
          </div>
          <div class="card CardItem" style="flex: 0 0 100%">
            <h5 class="chartHeading">Student Record 16</h5>
            <table
              id="table1"
              mat-table
              [dataSource]="dataSource2"
              multiTemplateDataRows
              class="mat-elevation-z8"
            >
              <ng-container
                matColumnDef="{{ column }}"
                *ngFor="let column of columnsToDisplay2"
              >
                <th mat-header-cell *matHeaderCellDef>{{ column }}</th>
                <td mat-cell *matCellDef="let element">{{ element[column] }}</td>
              </ng-container>
    
              <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
              <ng-container matColumnDef="expandedDetail">
                <td
                  mat-cell
                  *matCellDef="let element"
                  [attr.colspan]="columnsToDisplay2.length"
                >
                  <div
                    class="example-element-detail"
                    [@detailExpand]="
                      element == expandedElement ? 'expanded' : 'collapsed'
                    "
                  >
                    <div class="example-element-diagram">
                      <div class="example-element-position">
                        {{ element.position }}
                      </div>
                      <div class="example-element-symbol">{{ element.symbol }}</div>
                      <div class="example-element-name">{{ element.name }}</div>
                      <div class="example-element-weight">{{ element.weight }}</div>
                    </div>
                    <div class="example-element-description">
                      {{ element.description }}
                      <span class="example-element-description-attribution">
                        -- Wikipedia
                      </span>
                    </div>
                  </div>
                </td>
              </ng-container>
    
              <tr mat-header-row *matHeaderRowDef="columnsToDisplay2"></tr>
              <tr
                mat-row
                *matRowDef="let element; columns: columnsToDisplay2"
                class="example-element-row"
                [class.example-expanded-row]="expandedElement === element"
                (click)="
                  expandedElement = expandedElement === element ? null : element
                "
              ></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: ['expandedDetail']"
                class="example-detail-row"
              ></tr>
            </table>
            <mat-paginator
              #paginator2="matPaginator"
              [pageSize]="5"
              [pageSizeOptions]="[5, 10, 25, 100]"
              showFirstLastButtons
            >
            </mat-paginator>
          </div>
        </div>
    </div>
  
</mat-sidenav-container>


